import React from "react";
import { makeStyles, Spinner, Text } from "@fluentui/react-components";
import Customers from "./Customers";
import { useAdminAuth } from "../AdminAuthContext"
const useStyles = makeStyles({
    center: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "60vh",
        flexDirection: "column",
        gap: "12px",
    },
});

function ManageCustomers() {
    const { canManageCustomers, checkingManageAccess } = useAdminAuth();

    const styles = useStyles();
    // Loading state
    if (checkingManageAccess) {
        return (
            <div className={styles.center}>
                <Spinner size="large" />
                <Text>Checking access...</Text>
            </div>
        );
    }

    //  Access denied
    if (!canManageCustomers) {
        return (
            <div className={styles.center}>
                <Text weight="semibold">
                    You don’t have access to Manage Customers ❌
                </Text>
            </div>
        );
    }
    return (
        <Customers />
    );
}

export default React.memo(ManageCustomers);
